module.exports = __webpack_public_path__ + "static/img/part4.6296ed8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/part4.png
// module id = fmGy
// module chunks = 0